import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'prismjs/themes/prism-coy.css';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import App from './App';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
serviceWorker.unregister();
